import { SideNavInterface } from "../../interfaces/side-nav.type";

export const MARKETING_USER_ROUTES: SideNavInterface[] = [];

export const MARKETING_USER_LEAD_ROUTES: SideNavInterface[] = [
  {
    path: "mail",
    title: "Thông báo",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "notification",
    submenu: [
      {
        path: "/mail/push-notification",
        title: "Gửi thông báo",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "notification",
        submenu: [],
      },
      {
        path: "/mail/send-mail-marketing",
        title: "Soạn Mail",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "mail",
        submenu: [],
      },
      {
        path: "/mail/list-notification",
        title: "Lịch sử hoạt động",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "history",
        submenu: [],
      },
      {
        path: "/mail/schedule-notification",
        title: "Hẹn giờ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "hourglass",
        submenu: [],
      },
    ],
  },
  {
    path: "article",
    title: "Bài viết",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "file-search",
    submenu: [
      {
        path: "/article/management/newsFeeds",
        title: "Newsfeed",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "file-search",
        submenu: [],
      },
      {
        path: "/article/management/invest-in-knowledge",
        title: "Kiến thức đầu tư",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/article/management/newbie-knowledge",
        title: "Kiến thức cho người mới",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/product/e-gold-question",
        title: "Câu hỏi E Gold",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Thị trường",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "line-chart",
    submenu: [
      {
        path: "/product/market/funds",
        title: "Danh sách quỹ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "shop",
        submenu: [],
      },
      {
        path: "/product/market/fund-ranking",
        title: "Fund360",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "shop",
        submenu: [],
      },
    ],
  },
  {
    path: "product",
    title: "Sản phẩm",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "shop",
    submenu: [
      {
        path: "/product/stock",
        title: "Cổ phiếu",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "transaction",
        submenu: [],
      },
      {
        path: "/product/industry-stock",
        title: "Ngành Cổ phiếu",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "transaction",
        submenu: [],
      },
      {
        path: "/product/top-holding",
        title: "Top Holding",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "transaction",
        submenu: [],
      },
      {
        path: "/product/asset-holding",
        title: "Tỉ trọng loại tài sản",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "transaction",
        submenu: [],
      },
      {
        path: "/product/documents",
        title: "Tài liệu",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "transaction",
        submenu: [],
      },
    ],
  },
  {
    path: "/tool/qr-code",
    title: "QR Code",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "line-chart",
    submenu: [],
  },
  {
    path: "qa",
    title: "QA",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "file-search",
    submenu: [
      {
        path: "/qa/qacategory/list",
        title: "Danh mục câu hỏi",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "file-search",
        submenu: [],
      },
      // {
      //   path: '/blog/keyword/list',
      //   title: 'Câu hỏi',
      //   iconType: 'nzIcon',
      //   iconTheme: 'outline',
      //   icon: 'read',
      //   submenu: []
      // },
      {
        path: "/qa/qapost-article/list",
        title: "Q&A Post ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
    ],
  },
  {
    path: "blog",
    title: "Blog",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "file-search",
    submenu: [
      {
        path: "/blog/category/list",
        title: "Danh mục",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "file-search",
        submenu: [],
      },
      {
        path: "/blog/keyword/list",
        title: "Từ khóa",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/blog/post-article/list",
        title: "Bài viết",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
    ],
  },
  {
    path: "homepage",
    title: "Homepage",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "home",
    submenu: [
      {
        path: "/homepage/produc-information/list",
        title: "Sản phẩm",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "file-search",
        submenu: [],
      },
      {
        path: "/homepage/partner-information/list",
        title: "Đối tác",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/homepage/bank-interest-rate",
        title: "Lãi suất ngân hàng",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/homepage/share-social",
        title: "Hình ảnh share social",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
    ],
  },
  {
    path: "tracking",
    title: "Tracking",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "file-search",
    submenu: [
      {
        path: "/tracking/statictics",
        title: "Statistics",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "file-search",
        submenu: [],
      },
      {
        path: "/tracking/path-exploration",
        title: "Path exploration ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Bộ lọc khách hàng",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "filter",
    submenu: [
      {
        path: "/customer/filter/create",
        title: "Lọc khách hàng",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "filter",
        submenu: [],
      },
      {
        path: "/customer/filter/history",
        title: "Lịch sử lọc",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
    ],
  },
  {
    path: "fcara",
    title: "Fcara",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "file-search",
    submenu: [
      {
        path: "/fcara/budget/list",
        title: "Gói ngân sách",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "file-search",
        submenu: [],
      },
      {
        path: "/fcara/voucher/list",
        title: "Danh sách voucher",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
      },
      {
        path: "/fcara/hunt-voucher",
        title: "Săn thêm cara",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "file-search",
        submenu: [],
      },
      {
        path: "/fcara/quizgame/list",
        title: "Quizgame",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "file-search",
        submenu: [],
      },
    ],
  },
];
